import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 flex align-items-center justify-content-center px-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-flag-fill justify-content-center align-items-center text-base text-red-500" })
], -1)
const _hoisted_2 = { class: "col-10 px-0" }
const _hoisted_3 = { class: "title text-right" }
const _hoisted_4 = { class: "address text-xs text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 flex align-items-center justify-content-center px-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right cursor-pointer text-base text-black-alpha-20" })
], -1)


import { LINK_GOOGLE_MAP } from "@/clinic/typings/constants/clinic";

type IContentMessage = {
  type: string;
  content: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'location',
  props: {
    type: null,
    content: null
  },
  setup(__props: any) {

const props = __props as {
  type: string;
  content: any;
};


const openGoogleMaps = () => {
  const latitude = props.content.latitude;
  const longitude = props.content.longitude;
  const mapsUrl = `${LINK_GOOGLE_MAP}${latitude},${longitude}`;
  window.open(mapsUrl, "_blank");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "grid cursor-pointer",
    onClick: openGoogleMaps
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.content.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.content.address), 1)
    ]),
    _hoisted_5
  ]))
}
}

})